import React, { Component } from 'react';
import moment from 'moment-timezone';
import { Trans, translate } from 'react-i18next';
import axios from 'axios';

import * as $ from 'jquery';

let cancelToken;
let state;
let tokenSession;

class SummaryCowork extends Component {

  getInitState = () => {
    return {
      subtotal: "0",
      currency: "USD",
      credits: "0",
      iva: "0",
      total: "0",
    }
  }

  constructor(props) {
    super(props);
    if (tokenSession !== props.getTokenSession()) {
      state = this.getInitState();
    }
    this.state = state;
  }

  componentWillMount() {
    cancelToken = axios.CancelToken.source();
    this.reload();
  }

  componentWillUnmount() {
    cancelToken.cancel('Component will unmount.');
  }

  componentDidUpdate(prevProps) {
    if (this.props.duracion_id !== prevProps.duracion_id) {
      this.reload();
    }
  }

  componentDidMount() {
    this.reload();
  }

  //
  reload = () => {
    if (this.props.duracion_id == 1) {
      this.setState({
        subtotal: this.props.cowork.coworks_precio_day,
        iva: this.props.cowork.coworks_precio_day * .16,
        total: this.props.cowork.coworks_precio_day * 1.16,
      })
    } else if (this.props.duracion_id == 2) {
      this.setState({
        subtotal: this.props.cowork.coworks_precio_week,
        iva: this.props.cowork.coworks_precio_week * .16,
        total: this.props.cowork.coworks_precio_week * 1.16,
      })
    } else if (this.props.duracion_id == 3) {
      this.setState({
        subtotal: this.props.cowork.coworks_precio_year,
        iva: this.props.cowork.coworks_precio_year * .16,
        total: this.props.cowork.coworks_precio_year * 1.16,
      })
    } else if (this.props.duracion_id == 4) {
      const precio_hora = (Number(this.props.cowork.coworks_precio_hrs) * Number(this.props.duracion_hora))
      this.setState({
        subtotal: precio_hora,
        iva: precio_hora * .16,
        total: precio_hora * 1.16,
      })
    }
  }

  horarioSala = (start, end) => {
    return (
      <div className="panel-body">
        {start + " - " + end}
      </div>
    )
  }

  render() {
    const center = this.props.center
    const cowork = this.props.cowork
    const duracion = this.props.duracion
    const start_day = this.props.start_day
    const endDate = this.props.endDate
    const paymentDetails = this.state
    const { t } = this.props;

    return (
      <div className="card-panel panel panel-default card card_cowork">
        <div className="panel-heading-text">
          <h4 className="panel-title">{t('dashboard.room_payment.heading_summary')}</h4>
        </div>
        <div className="panel-heading" style={{ backgroundImage: "url('https://api.iosoffices.com/apiosfera/v4/src/uploads/cowork_imagenes/" + cowork.id + "')" }}>
        </div>
        <div className="panel-body">
          <div className="contenedor-flexbox">
            <div className="contenedor">
              <i className="fa fa-map-marker" aria-hidden="true"></i>
              {" "}{center.direccion},{center.ciudad},{center.estado}
            </div>
            <div className="contenedor">
              <i className="fa fa-calendar-o" aria-hidden="true"></i>
              {" "}{this.props.duracion_str}
            </div>
            <div className="contenedor">
              <i className="fa fa-calendar" aria-hidden="true"></i>
              {" "}{start_day}
            </div>
            <div className="contenedor">
              <i className="fa fa-calendar" aria-hidden="true"></i>
              {" "}{endDate}
            </div>
            {center.name ? (
              <div className="contenedor">
                <i className="fa fa-building-o" aria-hidden="true"></i>
                {" "}{center.name}
              </div>
            ) : null}
            <div className={"panel-footer"}>
              <div className="contenedor-flexbox-card">
                {this.props.duracion_id === '4' ? (
                  <div>
                    <div className="col-xs-6">
                      <p>Precio por Hora: </p>
                    </div>
                    <div className="col-xs-6">
                      <p>{"$" + this.props.cowork.coworks_precio_hrs + " " + paymentDetails.currency}</p>
                    </div>
                    <div className="col-xs-6">
                      <p>Horas Contratadas: </p>
                    </div>
                    <div className="col-xs-6">
                      <p>{this.props.duracion_hora + " Horas"}</p>
                    </div>
                  </div>
                ) : null}
                <div className="col-xs-6">
                  <p>{t('dashboard.room_payment.subtotal')}</p>
                </div>
                <div className="col-xs-6 text-primary">
                  <p>{"$" + Number(paymentDetails.subtotal).toFixed(2) + " " + paymentDetails.currency}</p>
                </div>
                <div className="col-xs-6">
                  <p>{t('dashboard.room_payment.iva')}</p>
                </div>
                <div className="col-xs-6 text-primary">
                  <p>{"$" + Number(paymentDetails.iva).toFixed(2) + " " + paymentDetails.currency}</p>
                </div>
                <div className="col-xs-6">
                  <p><strong>{t('dashboard.room_payment.total')}</strong></p>
                </div>
                <div className="col-xs-6 text-primary">
                  <p><strong>{"$" + Number(paymentDetails.total).toFixed(2) + " " + paymentDetails.currency}</strong></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className="btn btn-lg btn-primary btn-singup-help"
          type="button"
          style={{
            marginInline: "0px",
            color: "#000",
            backgroundColor: "#fff",
            border: "2px solid #000",
            height: '45%', width: '100%', borderRadius: '45px'
          }}
          onClick={() => $('#btnSuccessHelp').click()}
        >
          <span>
            <Trans>dashboard.contact.holder_message</Trans>
          </span>
        </button>
      </div>
    );
  }
}

export default translate('common')(SummaryCowork);



// WEBPACK FOOTER //
// ./src/store/Payment/SummaryCowork.js